// When these micro frontends unmount delete their modules from the module registry
// so a fresh instance will be loaded next time the micro frontend mounts.
const microFrontends = ['csn']

export default microFrontends
